<ng-template #impersonated>
  <div class="impersonated" *ngIf="user?.impersonated">
    <strong>You impersonate:</strong> {{ user?.name }}
    <button mat-button (click)="stopImpersonating()" title="Stop to impersonate the user">
      <mat-icon>dangerous</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #content>
  <router-outlet></router-outlet>
</ng-template>

<div class="loading" *ngIf="layoutObserver.showNav.value && localeObserver.availableLocales.length === 0">
  <mat-spinner></mat-spinner>
</div>

<mat-sidenav-container style="height: 100vh"
                       *ngIf="layoutObserver.showNav.value && localeObserver.availableLocales.length>0">
  <section>
    <nav class="navbar navbar-light bg-light navbar-expand-sm sticky-top">
      <div class="container-fluid">
        <a [routerLink]="['/']" class="navbar-brand" href="#" *ngIf="!searchObserver.searchVisible">
          <img class="logo" src="https://www.morebooks.shop/assets/img/logo.png"/>
        </a>
        <a class="navbar-brand" href="#" *ngIf="searchObserver.searchVisible"
           (click)="$event.preventDefault(); searchObserver.toggleSearchBar();">
          <img class="logo" src="https://www.morebooks.shop/assets/img/logo.png"/>
        </a>
        <div class="collapse navbar-collapse justify-content-end show">
          <ul class="navbar-nav">
            <li class="nav-item dropdown" dropdown *ngIf="layoutObserver.showLanguageSwitchObserver.value">
              <button dropdownToggle type="button" class="btn btn-default dropdown-toggle"
                      aria-controls="dropdown-basic">
                <img class="flag" [src]="getFlag(translate.currentLang||'')"/>
                <span class="d-none d-sm-inline-block">{{ 'language' | translate }} <span class="caret"></span></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem" *ngFor="let locale of localeObserver.availableLocales">
                  <a class="dropdown-item" (click)="switchLocale(locale.iso)">
                    <img class="flag" [src]="getFlag(locale.iso||'')"/>
                    <span [class.active]="translate.currentLang === locale.iso">{{ locale.languageName }}</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown" dropdown *ngIf="layoutObserver.showCurrencySwitchObserver.value">
              <button dropdownToggle type="button" class="btn btn-default dropdown-toggle"
                      aria-controls="dropdown-basic">
                <span class="badge bg-secondary currency">{{ currencyObserver.currentCurrency }}</span>
                <span class="d-none d-sm-inline-block">{{ 'cart.currency' | translate }} <span
                  class="caret"></span></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem" *ngFor="let currency of currencyObserver.currencies">
                  <a class="dropdown-item" (click)="currencyObserver.set(currency)">
                    <span [class.active]="currency.isActive">{{ currency.currency }} <span
                      class="badge bg-secondary">{{ currency.sign }}</span></span>
                  </a>
                </li>
              </ul>
            </li>
            <li *ngIf="layoutObserver.showSearchObserver.value">
              <button mat-icon-button aria-label="Cart icon" (click)="searchObserver.toggleSearchBar()"
                      [class.bounce]="searchBounce">
                <mat-icon *ngIf="!searchObserver.searchVisible">search</mat-icon>
                <mat-icon *ngIf="searchObserver.searchVisible"
                          #tooltip="matTooltip"
                          matTooltipShowDelay="500"
                          [matTooltip]="'search.click_to_close_search' | translate"
                          matTooltipPosition="above">search_off
                </mat-icon>
              </button>
            </li>
            <li *ngIf="layoutObserver.showCartObserver.value && cartObserver.cartItemCounterObserver.getValue()==0">
              <button mat-icon-button aria-label="Cart icon" (click)="cartObserver.toggleCart()" [class.bounce]="cartBounce">
                <mat-icon>shopping_cart</mat-icon>
              </button>
            </li>
            <li *ngIf="layoutObserver.showCartObserver.value && cartObserver.cartItemCounterObserver.getValue()>0">
              <button mat-icon-button aria-label="Cart icon" (click)="cartObserver.toggleCart()"
                      [matBadge]="cartObserver.cartItemCounterObserver.getValue()" [class.bounce]="cartBounce">
                <mat-icon>shopping_cart</mat-icon>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container-fluid">
      <ngx-loading-bar [color]="'#1a98d5'" [includeSpinner]="true" [height]="'6px'"
                       *ngIf="!cartObserver.cartVisible"></ngx-loading-bar>
      <ng-container *ngTemplateOutlet="impersonated"></ng-container>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </section>
  <mat-sidenav mode="over" position="end" [opened]="cartObserver.cartVisible" (closed)="cartObserver.hideCart()">
    <app-cart></app-cart>
  </mat-sidenav>

  <app-footer></app-footer>

</mat-sidenav-container>

<div style="height: 100vh" *ngIf="!layoutObserver.showNav.value">
  <ngx-loading-bar [color]="'#1a98d5'" [includeSpinner]="true" [height]="'6px'"
                   *ngIf="!cartObserver.cartVisible"></ngx-loading-bar>
  <ng-container *ngTemplateOutlet="impersonated"></ng-container>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
